import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'entitlements';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const LOAD_ORG_ENTITLEMENTS = createApiNamespacedConstants('LOAD_ORG_ENTITLEMENTS');
